import React, { useState, useEffect } from 'react';
import { UISelectLang } from '../components/composite';
import { UIToggleSwitch } from '../components/basic';
import { useLang } from '../../_LangContext';
import { useMapContext } from '../../_MapContext';
import { DEBUG_MODE, IS_PRODUCTION_DOMAIN } from '../../_DebugConfig';
import { APP_VERSION } from '../../../App';
import Utils from '../../_Utils';
import Cookies from 'js-cookie';

const MenuScreenSettings = ({ lang }) =>
{
    const { getText } = useLang();
    const { bfMapState, setBFMap, hasPinsState, setHasPins, gpsCheckEnabled, setGPSCheck } = useMapContext();

    //For DEBUG
    const [radius, setRadius] = useState(Utils.getCookie('stampcard_radius', '50'));
    const [fastPlayback, setFastPlayback] = useState(Utils.getCookie('sound_fast_playback', 'false') === 'true');

    const handleToggle = (key, value) => 
    {
        if (key === 'bf-map') 
        {
            setBFMap(value);
        } 
        else if (key === 'bf-map-pin') 
        {
            setHasPins(value ? 1 : 0);
        }
        else if (key === 'gps-check')
        {
            setGPSCheck(value);
            Utils.setCookie('gps_check_enabled', value.toString());
        }
        else if (key === 'fast-playback')
        {
            setFastPlayback(value);
            console.log('Changing fast playback to', value);
            Utils.setCookie('sound_fast_playback', value.toString());
        }
    };

    // Initialize states from cookies when component mounts
    useEffect(() =>
    {
        const isDebugMode = !IS_PRODUCTION_DOMAIN && DEBUG_MODE;

        // If DEBUG_MODE is false or on production domain, always set GPS check to true
        if (!isDebugMode) 
        {
            setGPSCheck(true);
        } 
        else 
        {
            const savedGPSCheck = Utils.getCookie('gps_check_enabled', 'false') === 'true';
            setGPSCheck(savedGPSCheck);
        }

        const savedFastPlayback = Utils.getCookie('sound_fast_playback', 'false') === 'true';
        setFastPlayback(savedFastPlayback);
    },
    [setGPSCheck]);

    const handleRadiusChange = (e) =>
    {
        const value = e.target.value;
        setRadius(value);
        Utils.setCookie('stampcard_radius', value);
    };

    const clearAllCookies = () =>
    {
        Object.keys(Cookies.get()).forEach(cookie =>
        {
            Cookies.remove(cookie);
        });
    };

    return (
        <div className="modal-screen settings" data-id="2">
            <div className="block setting-items">
                <dl className="setting-item">
                    <dt>{getText('language')}</dt>
                    <dd>
                        <UISelectLang />
                    </dd>
                </dl>
                <dl className="setting-item">
                    <dt>{getText('bf-map')}</dt>
                    <dd>
                        <UIToggleSwitch value={bfMapState} onChange={(value) => handleToggle('bf-map', value)} />
                    </dd>
                </dl>
                <dl className="setting-item">
                    <dt>{getText('bf-map-pin')}</dt>
                    <dd>
                        <UIToggleSwitch value={hasPinsState} onChange={(value) => handleToggle('bf-map-pin', value)} />
                    </dd>
                </dl>
            </div>
            {(!IS_PRODUCTION_DOMAIN && DEBUG_MODE) && (
                <div className="block setting-items debug">
                    <h3 className="block-title">デバッグ設定</h3>
                    <p className="app-version">APP VERSION: {APP_VERSION}</p>
                    <dl className="setting-item">
                        <dt>スタンプカードのGPS確認</dt>
                        <dd>
                            <UIToggleSwitch 
                                value={gpsCheckEnabled} 
                                onChange={(value) => handleToggle('gps-check', value)}
                            />
                        </dd>
                    </dl>
                    <dl className="setting-item">
                        <dt>スタンプカード半径 (m)</dt>
                        <dd>
                            <input 
                                type="number" 
                                value={radius} 
                                onChange={handleRadiusChange}
                                min="1"
                                max="1000"
                                step="1"
                            />
                        </dd>
                    </dl>
                    <dl className="setting-item">
                        <dt>音声の高速再生</dt>
                        <dd>
                            <UIToggleSwitch 
                                value={fastPlayback} 
                                onChange={(value) => handleToggle('fast-playback', value)}
                            />
                        </dd>
                    </dl>
                    <dl className="setting-item">
                        <dt>全Cookieクリア</dt>
                        <dd>
                            <button onClick={clearAllCookies}>クリア</button>
                        </dd>
                    </dl>
                </div>
            )}
        </div>
    );
};

export default MenuScreenSettings; 